import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Offer} from '../../../../../models/offer';
import {BehaviorSubject} from 'rxjs';
import {OfferService} from '../../../../../services/offer/offer.service';
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {LoaderService} from '../../../../../services/loader/loader.service';

import {IsGranted} from '../../../../../decorator/is-granted';

@Component({
  selector: 'app-offer-tab',
  imports: [
    RouterLinkActive,
    RouterLink,
    RouterOutlet
],
  templateUrl: './offer-tab.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './offer-tab.component.scss'
})
@IsGranted(['OFFER_VIEW'])
export class OfferTabComponent implements OnInit {
  protected offer: Offer | null = null;
  offerSubject = new BehaviorSubject<Offer | null>(null);

  constructor(
    private route: ActivatedRoute,
    private loader: LoaderService,
    private offerService: OfferService,
  ) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));

    if (id) {
      this.loader.startLoading();
      this.offerService.findOneById(id, {groups: 'goals,goal,goalTypes,goalType'}).subscribe(offer => {
        this.offer = offer;
        this.offerSubject.next(offer);
        this.loader.stopLoading();
      });
    }
  }
}
